import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c(VDialog, {
    attrs: {
      "persistent": "",
      "max-width": _vm.maxWidth
    },
    on: {
      "click:outside": function ($event) {
        return _vm.$emit('close');
      }
    },
    model: {
      value: _vm.isOpen,
      callback: function ($$v) {
        _vm.isOpen = $$v;
      },
      expression: "isOpen"
    }
  }, [_c(VCard, {
    class: _vm.title ? 'pt-0' : 'pt-4',
    attrs: {
      "data-cy": _vm.$attrs['data-cy']
    }
  }, [_vm.title ? _c(VCardTitle, {
    class: `pb-2 headline ${_vm.color}--text`
  }, [_vm._v(_vm._s(_vm.title))]) : _vm._e(), _c(VCardText, {
    staticClass: "pb-0"
  }, [_vm._t("default"), _vm.showSelect ? _c(VCheckbox, {
    staticClass: "pt-0 mt-0",
    attrs: {
      "label": _vm.checkBoxLable,
      "color": _vm.color,
      "hide-details": ""
    },
    on: {
      "change": function ($event) {
        return _vm.$emit('is-selectecd', _vm.itemIsSelected);
      }
    },
    model: {
      value: _vm.itemIsSelected,
      callback: function ($$v) {
        _vm.itemIsSelected = $$v;
      },
      expression: "itemIsSelected"
    }
  }) : _vm._e()], 2), _c(VCardActions, {
    staticClass: "pb-4"
  }, [_c(VSpacer), _vm._l(_vm.buttons, function (button, idx) {
    return _c(VBtn, {
      key: idx,
      attrs: {
        "data-cy": button.dataCy,
        "color": button.color || 'primary',
        "disabled": button.disabled,
        "text": ""
      },
      on: {
        "click": function ($event) {
          return _vm.handleButtonClick(idx);
        }
      }
    }, [button.icon ? _c('span', {
      staticClass: "button-icon"
    }, [_c(VIcon, {
      attrs: {
        "color": button.color,
        "size": "18"
      }
    }, [_vm._v(_vm._s(button.icon))])], 1) : _vm._e(), _vm._v("\n          " + _vm._s(button.text) + "\n        ")]);
  })], 2)], 1)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };